import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/axiosAuth";

// Async thunk for fetching orders per branch summary data
export const fetchOrdersPerBranchSummary = createAsyncThunk(
  "ordersBranchSource/fetchOrdersPerBranchSummary",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/api/orders-per-branch-summary",
        requestData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "حدث خطأ أثناء جلب البيانات"
      );
    }
  }
);

const ordersBranchSourceSlice = createSlice({
  name: "ordersBranchSource",
  initialState: {
    data: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    date: null,
    from_hour: null,
    to_hour: null,
  },
  reducers: {
    clearBranchData: (state) => {
      state.data = [];
      state.status = "idle";
      state.error = null;
      state.date = null;
      state.from_hour = null;
      state.to_hour = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrdersPerBranchSummary.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOrdersPerBranchSummary.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.branches || [];
        state.date = action.payload.date;
        state.from_hour = action.payload.from_hour;
        state.to_hour = action.payload.to_hour;
        state.error = null;
      })
      .addCase(fetchOrdersPerBranchSummary.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.data = [];
        state.date = null;
        state.from_hour = null;
        state.to_hour = null;
      });
  },
});

export const { clearBranchData } = ordersBranchSourceSlice.actions;
export default ordersBranchSourceSlice.reducer;
